import moment from 'moment';

import apiClient from '../lib/apiClient';

import {
  MEDICATION_CONSISTENCY,
  MEDICATION_LIST,
  MEDICATION_REMINDER,
} from '../constants/apiEndpoints';

import { CreateMedicationPayload } from '../pages/medications/addMedication/types';

export async function fetchMedications(patientId?: number) {
  const response = await apiClient.get(MEDICATION_LIST, {
    params: { patient_id: patientId },
  });

  return response.data?.data;
}

export async function createMedication(payload: CreateMedicationPayload) {
  const response = await apiClient.post(MEDICATION_LIST, payload);

  return response.data;
}

export async function deleteMedication(medicationId: number | undefined) {
  const response = await apiClient.delete(`${MEDICATION_LIST}/${medicationId}`);

  return response.data;
}

export async function fetchMedicationConsistency(
  patient_id: number | undefined,
  timeZone: string
) {
  const today = moment().tz(timeZone).startOf('day').toDate().toISOString();

  const response = await apiClient.get(
    `${MEDICATION_REMINDER}${MEDICATION_CONSISTENCY}`,
    { params: { patient_id, today } }
  );

  return response.data.data;
}

export async function fetchMedicationReminders(
  patientId: number,
  timeZone: string
) {
  const today = moment().tz(timeZone).startOf('day').toDate().toISOString();

  const response = await apiClient.get(MEDICATION_REMINDER, {
    params: {
      patient_id: patientId,
      date: today,
    },
  });

  return response.data.data;
}
